import React, {Component} from 'react';
import './css/SearchObituaries.styl';
import {connect} from 'react-redux';
import AppConfig from '../../../../../../appConfig/AppConfig';
import _get from 'lodash/get';

const config = AppConfig();

export class SearchObituaries extends Component {
  static propTypes = {
    affiliateName: React.PropTypes.string,
    funeralHome: React.PropTypes.object,
  };

  state = {
    firstName: '',
    lastName: '',
    searchError: false,
  };

  generateUrl() {
    const {affiliateName, funeralHome} = this.props;
    const {funeralHomeId} = funeralHome;

    if (affiliateName) {
      return `${
        config.vanityDomain
      }/obituaries/${affiliateName}/obituary-search.aspx?firstName=${
        this.state.firstName
      }&lastName=${this.state.lastName}&fhid=${funeralHomeId}&daterange=30`;
    }
    return `${config.vanityDomain}/search?firstName=${
      this.state.firstName
    }&lastName=${
      this.state.lastName
    }&fhid=${funeralHomeId}&daterange=Last30Days`;
  }

  buildSearchUrl = () => {
    if (this.state.firstName || this.state.lastName) {
      return this.setState({searchUrl: this.generateUrl(), searchError: false});
    }
    return this.setState({searchUrl: null, searchError: true});
  };

  handleFirstNameChange = e => {
    this.setState({firstName: e.target.value});
  };

  handleLastNameChange = e => {
    this.setState({lastName: e.target.value});
  };

  render() {
    return (
      <div className="search-obituaries__container">
        <div className="search-obituaries__form">
          <div className="search-obituaries__form-inner">
            <input
              className="search-obituaries__first-name"
              name="first_name"
              type="text"
              value={this.state.firstName}
              onChange={this.handleFirstNameChange}
              placeholder="First Name"
            />
            <input
              className="search-obituaries__last-name"
              name="last_name"
              type="text"
              value={this.state.lastName}
              onChange={this.handleLastNameChange}
              placeholder="Last Name"
            />
          </div>
          <a
            onClick={this.buildSearchUrl}
            href={this.state.searchUrl}
            className="large-button search-obituaries__button"
          >
            Search
          </a>
        </div>
        {this.state.searchError && (
          <p className="error">You must enter at least one value to proceed.</p>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  affiliateName: _get(state, 'affiliateStore.siteName'),
  funeralHome: state.funeralHomeStore,
});

export default connect(mapStateToProps)(SearchObituaries);



// WEBPACK FOOTER //
// ./src/reactModules/pages/Profile/components/Shared/SearchObituaries/SearchObituaries.js